import { SelectProps } from '@innovyze/lib_am_common';
import { TFunc } from '@Translations/types';

export const translatedFilters = (filters: SelectProps[], t: TFunc) =>
	filters.map(filter => {
		let filterCaption = filter.column.caption;
		switch (filterCaption) {
			case 'Grade':
				filterCaption = t('Grade');
				break;
			case 'Condition Data':
				filterCaption = t('Condition Data');
				break;
		}
		const options = filter.options.map(opt => {
			switch (opt.caption) {
				case 'Negligible':
					return { id: opt.id, caption: t('Negligible') };
				case 'Low':
					return { id: opt.id, caption: t('Low') };
				case 'Medium':
					return { id: opt.id, caption: t('Medium') };
				case 'High':
					return { id: opt.id, caption: t('High') };
				case 'Extreme':
					return { id: opt.id, caption: t('Extreme') };
				case 'No':
					return { id: opt.id, caption: t('No') };
				case 'Yes':
					return { id: opt.id, caption: t('Yes') };
				default:
					return opt;
			}
		});
		const column = { ...filter.column, caption: filterCaption };
		return { ...filter, column, options };
	});
